import { render, staticRenderFns } from "./different-compare.vue?vue&type=template&id=458f598e&scoped=true"
import script from "./different-compare.vue?vue&type=script&lang=ts"
export * from "./different-compare.vue?vue&type=script&lang=ts"
import style0 from "./different-compare.vue?vue&type=style&index=0&id=458f598e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f598e",
  null
  
)

export default component.exports